import React, { FC, useContext } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import makeStyles from '@material-ui/core/styles/makeStyles'
import DocumentVerificationIcon from 'components/DocumentVerificationIcon'
import { DocumentVerificationContext } from 'contexts/documentVerificationContext'
import { getOwnerVerificationSummary } from 'utils/documentVerificationHelpers'

const useOwnerVerificationStatusStyles = makeStyles(theme => ({
  status: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginLeft: theme.spacing(2),
  },
  tooltip: {
    maxWidth: 480,
  },
  result: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(1),
  },
  resultText: {
    marginLeft: theme.spacing(1.5),
  },
}))

interface IOwnerVerificationStatusProps {
  ownerId: number
}

const OwnerVerificationStatus: FC<IOwnerVerificationStatusProps> = ({ ownerId }) => {
  const classes = useOwnerVerificationStatusStyles()
  const verification = useContext(DocumentVerificationContext)
  const summary = verification ? getOwnerVerificationSummary(verification, ownerId) : undefined

  if (!summary) return null

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={
        <>
          {summary.checkedAgainst.length > 0 && <div>Checked against: {summary.checkedAgainst.join(', ')}</div>}
          {summary.findings.map(finding => (
            <div key={finding.label} className={classes.result}>
              <DocumentVerificationIcon severity={finding.severity} />
              <span className={classes.resultText}>
                {finding.label}: {finding.message}
              </span>
            </div>
          ))}
          {summary.matchedFields.length > 0 && (
            <div className={classes.result}>
              <DocumentVerificationIcon severity="success" />
              <span className={classes.resultText}>Matches: {summary.matchedFields.join(', ')}</span>
            </div>
          )}
        </>
      }
    >
      <span className={classes.status}>
        <DocumentVerificationIcon severity={summary.severity} />
      </span>
    </Tooltip>
  )
}

export default OwnerVerificationStatus
